<template>
    <div>
        <el-tag
                v-for="device in initialSelectedDevices"
                :key='device.id'
                closable
                :title="device.name"
                :disable-transitions="(false)"
                @close="handleClose(device)">
            {{ (device.extensionName != null && device.extensionName != '') ?
            device.extensionName : device.name }}
        </el-tag>
        <el-autocomplete
                v-model="search"
                size="small"
                value-key="name"
                style="margin-left:10px; max-width: 180px;"
                :fetch-suggestions="querySearch"
                placeholder="Search Devices"
                @select="handleSelect($event)"
        ></el-autocomplete>
    </div>
</template>

<script>
    import {mapFields} from "vuex-map-fields";

    export default {
        name: "SIPDeviceSelector",
        props: {
            initialSelectedDevices: Array,
        },
        computed: {
            ...mapFields(`sipdevice`, ['sipdevices']),
        },
        data() {
            return {
                search: '',
            }
        },
        methods: {
            querySearch(queryString, cb) {
                var sipdevices = this.sipdevices;
                var results = queryString ? sipdevices.filter(this.createFilter(queryString)).map(s => {
                    let name = (s.extensionName != null && s.extensionName != '') ? s.extensionName : s.name;
                    return {name: name, value: s.name}
                }) : sipdevices.map(s => {
                    let name = (s.extensionName != null && s.extensionName != '') ? s.extensionName : s.name;
                    return {name: name, value: s.name}
                });
                cb(results);
            },
            createFilter(queryString) {
                return (sipdevice) => {
                    let nameExists = sipdevice.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
                    let extensionNameExists = (sipdevice.extensionName != null && sipdevice.extensionName != '') ? sipdevice.extensionName.toLowerCase().indexOf(queryString.toLowerCase()) === 0 : false;
                    return (nameExists || extensionNameExists);
                };
            },
            handleSelect(name) {
                let device = this.sipdevices.filter(d => {
                    return d.name === name.value || d.extenstionName === name.name
                })[0];

                if (!device) {
                    return;
                }
                //Device already in list.
                if (this.initialSelectedDevices.filter(d => d.name === name.value).length > 0) {
                    this.$notify({
                        position: "bottom-right",
                        message: 'Device is already in the list!',
                        type: "error",
                        icon: "fal fa-times",
                        title: "Error!"
                    });
                    this.search = '';
                    return;
                }
                this.$emit('add', {device});
                this.search = '';
            },
            handleClose(device) {
                let name = device.name;
                this.$emit('remove', {name});
                // this.selectedDevices = this.selectedDevices.filter(d => d.name !== name);

            },
        },
        mounted() {
            if (this.$store.getters['sipdevice/needUpdate']) {
                this.$store.dispatch('sipdevice/loadSIPDevices');
            }
        }
    }
</script>

<style scoped>

</style>